if (!customElements.get('top-restock')) customElements.define('top-restock', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.data = JSON.parse(this.querySelector('[data-restock-data]').textContent);
    this.unavailable = this.data.variants.filter(v => !v.available);
    this.dialog = this.querySelector('dialog');
    this.trigger = this.querySelector('[data-restock-trigger]');
    this.select = this.querySelector('[data-restock-variant]');
    this.form = this.querySelector('[data-restock-form]');
    this.email = this.querySelector('[data-restock-email]');
    this.status = this.querySelector('[data-restock-status]');
    this.submit = this.form.querySelector('[type="submit"]');
    this.scope = this.hasAttribute('data-card') ? this : document.getElementById('shopify-section-' + this.dataset.section);
    if (!this.scope || !this.unavailable.length) return;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    const uid = 'restock-' + crypto.randomUUID();
    this.dialog.id = uid;
    this.dialog.querySelector('h2').id = uid + '-title';
    this.dialog.setAttribute('aria-labelledby', uid + '-title');
    this.select.id = uid + '-variant';
    this.email.id = uid + '-email';
    const labels = this.form.querySelectorAll('label');
    labels[0].htmlFor = this.select.id;
    labels[1].htmlFor = this.email.id;
    this.unavailable.forEach(v => this.select.add(new Option(v.title === 'Default Title' ? this.data.title : v.title, String(v.id))));
    const sync = () => {
      const batch = this.scope.querySelector('top-lash-order:not([hidden])');
      const hidden = Boolean(batch);
      if (this.trigger.hidden !== hidden) this.trigger.hidden = hidden;
    };
    this.observer = new MutationObserver(sync);
    this.observer.observe(this.scope, {childList:true,subtree:true,attributes:true,attributeFilter:['hidden']});
    this.trigger.addEventListener('click', () => this.open(this.dataset.selected), {signal});
    if (!this.hasAttribute('data-card')) this.scope.addEventListener('top:restock', e => this.open(e.detail.id), {signal});
    document.addEventListener(`variant:change:${this.dataset.section}:${this.dataset.product}`, e => {
      const fresh = e.detail.html?.querySelector('top-restock');
      if (fresh) this.dataset.selected = fresh.dataset.selected;
    }, {signal});
    this.dialog.querySelector('[data-restock-close]').addEventListener('click', () => this.dialog.close(), {signal});
    this.dialog.addEventListener('close', () => this.opener?.isConnected && this.opener.focus(), {signal});
    this.form.addEventListener('submit', e => this.subscribe(e), {signal});
    document.body.append(this.dialog);
    sync();
  }
  open(id) {
    if (this.busy) return;
    this.opener = document.activeElement;
    this.form.hidden = false;
    this.status.textContent = '';
    const variant = this.unavailable.find(v => String(v.id) === String(id)) || this.unavailable[0];
    this.select.value = String(variant.id);
    this.dialog.showModal();
    this.email.focus();
  }
  async subscribe(event) {
    event.preventDefault();
    if (this.busy || !this.form.reportValidity()) return;
    const variant = this.unavailable.find(v => String(v.id) === this.select.value);
    if (!variant) return;
    this.busy = true;
    this.submit.disabled = true;
    this.select.disabled = true;
    this.status.textContent = this.data.text.sending;
    try {
      const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(this.dataset.company)}`, {
        method:'POST',
        headers:{'Content-Type':'application/vnd.api+json','revision':'2026-07-15'},
        body:JSON.stringify({data:{type:'back-in-stock-subscription',attributes:{channels:['EMAIL'],profile:{data:{type:'profile',attributes:{email:this.email.value.trim()}}}},relationships:{variant:{data:{type:'catalog-variant',id:`$shopify:::$default:::${variant.id}`}}}}})
      });
      if (!response.ok) throw new Error('subscription');
      this.form.hidden = true;
      this.status.textContent = this.data.text.success;
    } catch (_) {
      this.status.textContent = this.data.text.error;
    } finally {
      this.busy = false;
      this.submit.disabled = false;
      this.select.disabled = false;
    }
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
    this.observer?.disconnect();
    this.dialog?.remove();
  }
});

